import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Card, Spinner, Alert, Badge, Table, Row, Col } from "react-bootstrap";
import axios from "axios";
import { API_URL } from "../../services/api";

const DetailReguler = () => {
  const { id_reg } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Get filter state from navigation (passed from DaftarPengajuanReguler)
  const filterState = location.state?.filterState;

  useEffect(() => {
    fetchDetail();
  }, [id_reg]);

  const fetchDetail = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await axios.get(
        `${API_URL}/reguler/info-registrasi/${id_reg}`
      );

      if (response.data.success) {
        setData(response.data.data);
      } else {
        setError(response.data.message || "Gagal mengambil data detail");
      }
    } catch (err) {
      console.error("Error fetching detail:", err);
      setError(err.response?.data?.message || "Terjadi kesalahan saat mengambil data");
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("id-ID", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  const SectionCard = ({ title, icon, children }) => (
    <Card className="mb-4 shadow-sm">
      <Card.Header className="bg-primary text-white">
        <h6 className="mb-0">
          <i className={`fas ${icon} me-2`}></i>
          {title}
        </h6>
      </Card.Header>
      <Card.Body>{children}</Card.Body>
    </Card>
  );

  const Field = ({ label, value }) => (
    <div className="mb-2">
      <small className="text-muted">{label}</small>
      <p className="mb-0 fw-medium">{value || "-"}</p>
    </div>
  );

  if (loading) {
    return (
      <div className="container-fluid py-4 text-center">
        <Spinner animation="border" variant="primary" />
        <p className="mt-2">Memuat data...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container-fluid py-4">
        <Alert variant="danger">
          <i className="fas fa-exclamation-triangle me-2"></i>
          {error}
        </Alert>
        <button
          className="btn btn-secondary"
          onClick={() => navigate("/admin/reguler/daftar-pengajuan", { state: { filterState } })}
        >
          <i className="fas fa-arrow-left me-2"></i>
          Kembali
        </button>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="container-fluid py-4">
        <Alert variant="warning">Data tidak ditemukan</Alert>
        <button
          className="btn btn-secondary mt-3"
          onClick={() => navigate("/admin/reguler/daftar-pengajuan", { state: { filterState } })}
        >
          <i className="fas fa-arrow-left me-2"></i>
          Kembali
        </button>
      </div>
    );
  }

  const { pengajuan, kbli, bahan, produk, tracking, aspek_legal, pabrik, penyelia } = data;

  // Function to go back with filter state
  const handleBack = () => {
    navigate("/admin/reguler/daftar-pengajuan", { state: { filterState } });
  };

  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4>
          <i className="fas fa-file-alt me-2"></i>
          Detail Registrasi Reguler
        </h4>
        <button className="btn btn-secondary" onClick={handleBack}>
          <i className="fas fa-arrow-left me-2"></i>
          Kembali
        </button>
      </div>

      {/* Info Pengajuan */}
      <SectionCard title="Informasi Pengajuan" icon="fa-file-alt">
        <Row>
          <Col md={6}>
            <Field label="No. Daftar" value={pengajuan?.no_daftar} />
            <Field label="Nama PU" value={pengajuan?.nama_pu} />
            <Field label="Nama PU SH" value={pengajuan?.nama_pu_sh} />
            <Field label="Status Registrasi" value={pengajuan?.status_reg} />
            <Field label="Jenis Daftar" value={pengajuan?.jenis_daftar} />
          </Col>
          <Col md={6}>
            <Field label="Tanggal Daftar" value={formatDate(pengajuan?.tgl_daftar)} />
            <Field label="Tanggal Mohon" value={formatDate(pengajuan?.tgl_mohon)} />
            <Field label="Skala Usaha" value={pengajuan?.skala_usaha} />
            <Field label="Jenis Usaha" value={pengajuan?.jenis_usaha} />
            <Field label="Nama LPH" value={pengajuan?.nama_lph} />
          </Col>
        </Row>
      </SectionCard>

      {/* Kontak */}
      <SectionCard title="Kontak & Alamat" icon="fa-address-card">
        <Row>
          <Col md={6}>
            <Field label="Email" value={pengajuan?.email} />
            <Field label="No. Telp" value={pengajuan?.no_telp} />
            <Field label="Nama PJ" value={pengajuan?.nama_pj} />
            <Field label="Email PJ" value={pengajuan?.email_pj} />
            <Field label="No. Kontak PJ" value={pengajuan?.no_kontak_pj} />
          </Col>
          <Col md={6}>
            <Field label="Alamat PU" value={pengajuan?.alamat_pu} />
            <Field label="Provinsi" value={pengajuan?.prov_pu} />
            <Field label="Kota" value={pengajuan?.kota_pu} />
            <Field label="Kode Pos" value={pengajuan?.kode_pos_pu} />
            <Field label="Negara" value={pengajuan?.negara_pu} />
          </Col>
        </Row>
      </SectionCard>

      {/* Produk */}
      <SectionCard title="Produk" icon="fa-box">
        <Row>
          <Col md={6}>
            <Field label="Jenis Layanan" value={pengajuan?.jenis_layanan} />
            <Field label="Jenis Produk" value={pengajuan?.jenis_produk} />
            <Field label="Merek Dagang" value={pengajuan?.merek_dagang} />
          </Col>
          <Col md={6}>
            <Field label="Area Pemasaran" value={pengajuan?.area_pemasaran} />
            <Field label="Channel ID" value={pengajuan?.channel_id} />
            <Field label="No. Mohon" value={pengajuan?.no_mohon} />
          </Col>
        </Row>
      </SectionCard>

      {/* KBLI */}
      {kbli && kbli.length > 0 && (
        <SectionCard title={`KBLI (${kbli.length})`} icon="fa-industry">
          <Table striped bordered hover size="sm">
            <thead className="table-dark">
              <tr>
                <th>KBLI</th>
                <th>Nama KBLI</th>
                <th>ID Izin</th>
                <th>ID Produk</th>
              </tr>
            </thead>
            <tbody>
              {kbli.map((item, index) => (
                <tr key={index}>
                  <td>{item.kbli}</td>
                  <td>{item.nama_kbli}</td>
                  <td>{item.id_izin || "-"}</td>
                  <td>{item.id_produk || "-"}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </SectionCard>
      )}

      {/* Aspek Legal */}
      {aspek_legal && aspek_legal.length > 0 && (
        <SectionCard title={`Aspek Legal (${aspek_legal.length})`} icon="fa-gavel">
          <Table striped bordered hover size="sm">
            <thead className="table-dark">
              <tr>
                <th>Jenis Surat</th>
                <th>No. Surat</th>
                <th>Tgl. Surat</th>
                <th>Instansi Penerbit</th>
                <th>Masa Berlaku</th>
              </tr>
            </thead>
            <tbody>
              {aspek_legal.map((item, index) => (
                <tr key={item.id || index}>
                  <td>{item.jenis_surat}</td>
                  <td>{item.no_surat}</td>
                  <td>{formatDate(item.tgl_surat)}</td>
                  <td>{item.instansi_penerbit}</td>
                  <td>{formatDate(item.masa_berlaku)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </SectionCard>
      )}

      {/* Pabrik */}
      {pabrik && pabrik.length > 0 && (
        <SectionCard title={`Pabrik (${pabrik.length})`} icon="fa-building">
          {pabrik.map((item, index) => (
            <Card key={item.id_fas || index} className="mb-2 border">
              <Card.Body>
                <Row>
                  <Col md={6}>
                    <Field label="Nama" value={item.nama} />
                    <Field label="Alamat" value={item.alamat} />
                    <Field label="Status Milik" value={item.nama_status || item.status_milik} />
                  </Col>
                  <Col md={6}>
                    <Field label="Kab/Kota" value={item.kab_kota} />
                    <Field label="Provinsi" value={item.provinsi} />
                    <Field label="Kode Pos" value={item.kode_pos} />
                    <Field label="Negara" value={item.negara} />
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          ))}
        </SectionCard>
      )}

      {/* Penyelia */}
      {penyelia && penyelia.length > 0 && (
        <SectionCard title={`Penyelia (${penyelia.length})`} icon="fa-user-tie">
          {penyelia.map((item, index) => (
            <Card key={item.penyelia_id || index} className="mb-2 border">
              <Card.Body>
                <Row>
                  <Col md={6}>
                    <Field label="Nama" value={item.nama} />
                    <Field label="No. KTP" value={item.no_ktp} />
                    <Field label="Agama" value={item.agama} />
                    <Field label="No. Kontak" value={item.no_kontak} />
                  </Col>
                  <Col md={6}>
                    <Field label="No. Sertifikat" value={item.no_sertifikat} />
                    <Field label="Tgl. Sertifikat" value={formatDate(item.tgl_sertifikat)} />
                    <Field label="No. SK" value={item.no_sk} />
                    <Field label="Tgl. SK" value={formatDate(item.tgl_sk)} />
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          ))}
        </SectionCard>
      )}

      {/* Bahan */}
      {bahan && bahan.length > 0 && (
        <SectionCard title={`Bahan (${bahan.length})`} icon="fa-flask">
          <Table striped bordered hover size="sm" style={{ fontSize: "0.8rem" }}>
            <thead className="table-dark">
              <tr>
                <th>Nama Bahan</th>
                <th>Jenis</th>
                <th>Kelompok</th>
                <th>Produsen</th>
                <th>No. Sertifikat Halal</th>
                <th>Merek</th>
              </tr>
            </thead>
            <tbody>
              {bahan.map((item, index) => (
                <tr key={item.id_reg_bahan || index}>
                  <td>{item.reg_nama_bahan}</td>
                  <td>
                    <Badge bg={item.jenis_bahan?.includes("certified") ? "success" : "warning"}>
                      {item.jenis_bahan?.split("|")[1] || item.jenis_bahan}
                    </Badge>
                  </td>
                  <td>{item.kelompok || "-"}</td>
                  <td>{item.produsen || "-"}</td>
                  <td>{item.no_sertifikat_halal || "-"}</td>
                  <td>{item.merek || "-"}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </SectionCard>
      )}

      {/* Produk */}
      {produk && produk.length > 0 && (
        <SectionCard title={`Produk (${produk.length})`} icon="fa-shopping-bag">
          <Table striped bordered hover size="sm">
            <thead className="table-dark">
              <tr>
                <th>No</th>
                <th>Nama Produk</th>
                <th>Jumlah Bahan</th>
              </tr>
            </thead>
            <tbody>
              {produk.map((item, index) => (
                <tr key={item.id_reg_prod || index}>
                  <td>{index + 1}</td>
                  <td>{item.reg_prod_name}</td>
                  <td>{item.jumlah_bahan}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </SectionCard>
      )}

      {/* Tracking */}
      {tracking && tracking.length > 0 && (
        <SectionCard title={`Tracking (${tracking.length})`} icon="fa-history">
          <div className="timeline">
            {tracking.map((item, index) => (
              <div key={item.log_id || index} className="mb-3 pb-3 border-bottom">
                <div className="d-flex justify-content-between">
                  <Badge bg="primary">{item.status}</Badge>
                  <small className="text-muted">{formatDate(item.tanggal)}</small>
                </div>
                <p className="mb-1 fw-medium">{item.status_desc}</p>
                <p className="mb-1 small">
                  <i className="fas fa-user me-1"></i>
                  {item.userid}
                </p>
                {item.keterangan && (
                  <p className="mb-0 small text-muted" style={{ whiteSpace: "pre-wrap" }}>
                    {item.keterangan}
                  </p>
                )}
              </div>
            ))}
          </div>
        </SectionCard>
      )}
    </div>
  );
};

export default DetailReguler;
